import { apiBaseUrl } from './api';

export const defaultSlugEntries = [
  // {
  //   slug: 'camera-securite',
  //   type: 'category',
  //   categoryId: 'security-cameras',
  //   label: 'Caméras de sécurité',
  //   relatedLinks: [
  //     { slug: 'camera-securite-exterieure', label: 'Caméras extérieures' },
  //     { slug: 'camera-securite-interieure', label: 'Caméras intérieures' },
  //     { slug: 'enregistreur-video-reseau', label: 'Enregistreurs vidéo réseau' },
  //     { slug: 'accessoires-cameras', label: 'Accessoires pour caméras' },
  //   ],
  //   guideLink: {
  //     url: '/camera-securite',
  //     label: 'Voir le guide',
  //   },
  // },
  // {
  //   slug: 'camera-securite-exterieure',
  //   type: 'subcategory',
  //   categoryId: 'security-cameras',
  //   subcategoryId: 'outdoor-cameras',
  //   parentSlug: 'camera-securite',
  //   label: 'Caméras extérieures',
  //   relatedLinks: [
  //     { slug: 'camera-securite-exterieure-wifi', label: 'Caméras extérieures Wi‑Fi' },
  //     { slug: 'camera-securite-exterieure-poe', label: 'Caméras extérieures PoE' },
  //     { slug: 'camera-securite-exterieure-reolink', label: 'Caméras extérieures Reolink' },
  //     { slug: 'enregistreur-video-reseau', label: 'Enregistreurs vidéo réseau' }
  //   ],
  //   guideLink: {
  //     url: '/camera-securite/camera-securite-exterieure',
  //     label: 'Voir le guide',
  //   },
  // },
  // {
  //   slug: 'camera-securite-exterieure-wifi',
  //   type: 'subcategory',
  //   categoryId: 'security-cameras',
  //   subcategoryId: 'outdoor-cameras',
  //   label: 'Caméras extérieures Wi‑Fi',
  //   searchQuery: {
  //     category: 'security-cameras',
  //     subcategory: 'outdoor-cameras',
  //     connectivity: 'has_any:wifi',
  //   },
  //   relatedLinks: [
  //     { slug: 'camera-securite-exterieure', label: 'Toutes les caméras extérieures' },
  //     { slug: 'camera-securite-exterieure-poe', label: 'Caméras extérieures PoE' },
  //     { slug: 'camera-securite-exterieure-reolink', label: 'Caméras extérieures Reolink' },
  //     { slug: 'enregistreur-video-reseau', label: 'Enregistreurs vidéo réseau' }
  //   ],
  // },
  // {
  //   slug: 'camera-securite-exterieure-poe',
  //   type: 'subcategory',
  //   categoryId: 'security-cameras',
  //   subcategoryId: 'outdoor-cameras',
  //   label: 'Caméras extérieures PoE',
  //   searchQuery: {
  //     category: 'security-cameras',
  //     subcategory: 'outdoor-cameras',
  //     connectivity: 'has_any:poe',
  //   },
  //   relatedLinks: [
  //     { slug: 'camera-securite-exterieure', label: 'Toutes les caméras extérieures' },
  //     { slug: 'camera-securite-interieure', label: 'Caméras intérieures' },
  //     { slug: 'enregistreur-video-reseau', label: 'Enregistreurs vidéo réseau' },
  //     { slug: 'accessoires-cameras', label: 'Accessoires pour caméras' }
  //   ],
  // },
  // {
  //   slug: 'camera-securite-interieure',
  //   type: 'subcategory',
  //   categoryId: 'security-cameras',
  //   subcategoryId: 'indoor-cameras',
  //   parentSlug: 'camera-securite',
  //   label: 'Caméras intérieures',
  //   relatedLinks: [
  //     { slug: 'camera-securite-exterieure', label: 'Caméras extérieures' },
  //     { slug: 'camera-securite-interieur-wifi', label: 'Caméras intérieures Wi‑Fi' },
  //     { slug: 'enregistreur-video-reseau', label: 'Enregistreurs vidéo réseau' },
  //     { slug: 'accessoires-cameras', label: 'Accessoires pour caméras' }
  //   ],
  //   guideLink: {
  //     url: '/camera-securite/camera-securite-interieure',
  //     label: 'Voir le guide',
  //   },
  // },
  // {
  //   slug: 'camera-securite-interieur-wifi',
  //   type: 'subcategory',
  //   categoryId: 'security-cameras',
  //   subcategoryId: 'indoor-cameras',
  //   label: 'Caméras intérieures Wi‑Fi',
  //   searchQuery: {
  //     category: 'security-cameras',
  //     subcategory: 'indoor-cameras',
  //     connectivity: 'has_any:wifi',
  //   },
  //   relatedLinks: [
  //     { slug: 'camera-securite-exterieure', label: 'Caméras extérieures' },
  //     { slug: 'camera-securite-interieure', label: 'Caméras intérieures' },
  //     { slug: 'enregistreur-video-reseau', label: 'Enregistreurs vidéo réseau' },
  //     { slug: 'accessoires-cameras', label: 'Accessoires pour caméras' }
  //   ],
  // },
  // {
  //   slug: 'accessoires-cameras',
  //   type: 'subcategory',
  //   categoryId: 'security-cameras',
  //   subcategoryId: 'security-cameras-accessories',
  //   label: 'Accessoires pour caméras de sécurité',
  //   relatedLinks: [
  //     { slug: 'camera-securite-exterieure', label: 'Caméras extérieures' },
  //     { slug: 'camera-securite-interieure', label: 'Caméras intérieures' },
  //     { slug: 'camera-securite-exterieure-wifi', label: 'Caméras extérieures Wi‑Fi' },
  //     { slug: 'camera-securite-interieur-wifi', label: 'Caméras intérieures Wi‑Fi' },
  //   ],
  // },
  // {
  //   slug: 'enregistreur-video-reseau',
  //   type: 'category',
  //   categoryId: 'network-video-recorders',
  //   label: 'Enregistreurs vidéo réseau',
  //   relatedLinks: [
  //     { slug: 'camera-securite', label: 'Caméras de sécurité' }],
  //   guideLink: {
  //     url: '/enregistreur-video-reseau',
  //     label: 'Voir le guide NVR',
  //   },
  // },
  // {
  //   slug: 'babyphone-veilleuse',
  //   type: 'category',
  //   categoryId: 'baby-monitor',
  //   label: 'Babyphones et veilleuses',
  //   guideLink: {
  //     url: '/babyphone-connecte',
  //     label: 'Voir le guide babyphone connecté',
  //   },
  // },

];

let slugEntries = [];
let slugEntriesLoaded = false;
let slugEntriesPromise = null;

export const setSlugEntries = entries => {
  slugEntries = Array.isArray(entries) ? entries : [];
  return slugEntries;
};

export const loadSlugEntries = async (marketplaceRootURL, options = {}) => {
  const { force = false } = options;
  if (force) {
    slugEntriesLoaded = false;
    slugEntriesPromise = null;
  }
  if (slugEntriesLoaded) return slugEntries;
  if (slugEntriesPromise) return slugEntriesPromise;
  slugEntriesPromise = (async () => {
  try {
    const baseUrl = apiBaseUrl(marketplaceRootURL);
    const response = await fetch(`${baseUrl}/api/category-slugs`, {
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    });
    if (!response.ok) {
      setSlugEntries([]);
      return slugEntries;
    }
    const data = await response.json();
    if (Array.isArray(data?.items)) {
      setSlugEntries(
        data.items.map(item => ({
          id: item.id,
          slug: item.slug,
          type: item.type,
          categoryId: item.category_id,
          subcategoryId: item.subcategory_id || item.search_query?.subcategory || null,
          label: item.label,
          relatedLinks: item.related_links || [],
          guideLink: item.guide_link || null,
          comparatorCta: item.comparator_cta || null,
          searchQuery: item.search_query || null,
          seo: item.seo || null,
        }))
      );
    } else {
      setSlugEntries([]);
    }
    slugEntriesLoaded = true;
  } catch (_) {
    setSlugEntries([]);
  }
  return slugEntries;
  })();
  return slugEntriesPromise;
};

export const areSlugEntriesLoaded = () => slugEntriesLoaded;
export const getSlugEntriesCount = () => slugEntries.length;

export const ensureSlugEntries = async marketplaceRootURL => {
  const shouldForce = !slugEntriesLoaded || slugEntries.length === 0;
  return loadSlugEntries(marketplaceRootURL, { force: shouldForce });
};

export const findSlugEntry = slug => slugEntries.find(entry => entry.slug === slug) || null;

export const buildSearchParamsFromSlugEntry = entry => {
  if (!entry) return {};
  if (entry.searchQuery && Object.keys(entry.searchQuery).length > 0) {
    return entry.searchQuery;
  }
  if (entry.type === 'category' && entry.categoryId) {
    return { pub_categoryLevel1: entry.categoryId };
  }
  if (entry.type === 'subcategory' && entry.categoryId && entry.subcategoryId) {
    return {
      pub_categoryLevel1: entry.categoryId,
      pub_categoryLevel2: entry.subcategoryId,
    };
  }
  if (entry.type === 'subcategory' && entry.categoryId) {
    return { pub_categoryLevel1: entry.categoryId };
  }
  return {};
};

export const getSlugSearchParams = (params = {}, config = {}) => {
  const slug = params?.slug;
  if (slug == null || slug === '') return {};
  const entry = findSlugEntry(slug);
  if (entry) return buildSearchParamsFromSlugEntry(entry);

  const brands = config?.brandConfiguration?.brands || [];
  const hasBrand = brands.some(brand => brand?.id === slug);
  if (hasBrand) {
    return { pub_brand: `has_any:${slug}` };
  }

  const listingTypes = config?.listing?.listingTypes || [];
  const hasListingType = listingTypes.some(listingType => listingType?.listingType === slug);
  if (hasListingType) {
    return { pub_listingType: slug };
  }

  return {};
};

export const getCategoryEntryById = categoryId =>
  slugEntries.find(entry => entry.type === 'category' && entry.categoryId === categoryId) || null;

export const getSubcategoryEntriesByCategoryId = categoryId =>
  slugEntries.filter(entry => entry.type === 'subcategory' && entry.categoryId === categoryId);

export const getSubcategoryEntryByIds = (categoryId, subcategoryId) =>
  slugEntries.find(
    entry =>
      entry.type === 'subcategory' &&
      entry.categoryId === categoryId &&
      entry.subcategoryId === subcategoryId
  ) || null;

export const getSiblingSubcategoryEntries = entry => {
  if (!entry?.categoryId) return [];
  return getSubcategoryEntriesByCategoryId(entry.categoryId).filter(
    sibling => sibling.slug !== entry.slug
  );
};

export const getLabelForSlug = slug => {
  const entry = findSlugEntry(slug);
  return entry?.label || slug;
};

export const getRelatedLinks = entry => {
  const links = Array.isArray(entry?.relatedLinks) ? entry.relatedLinks : [];
  return links
    .map(link => ({
      slug: link.slug,
      label: link.label || getLabelForSlug(link.slug),
    }))
    .filter(link => link.slug);
};

export const getSeoByCategoryIds = (categoryId, subcategoryId) => {
  if (!categoryId) return null;
  if (subcategoryId) {
    const sub = slugEntries.find(
      entry =>
        entry.type === 'subcategory' &&
        entry.categoryId === categoryId &&
        entry.subcategoryId === subcategoryId
    );
    if (sub?.seo) return sub.seo;
  }
  const cat = slugEntries.find(
    entry => entry.type === 'category' && entry.categoryId === categoryId
  );
  return cat?.seo || null;
};

export const getSlugEntries = () => slugEntries;


